// Kod promocyjny: „MINUS" celowo mniejszą czcionką niż „50" (czytelność hasła).
export const PromoCode = () => (
    <span className="whitespace-nowrap">
        <span className="text-[0.55em] font-extrabold">MINUS</span>
        <span className="font-extrabold">50</span>
    </span>
);
